import { FC, useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { useAuth } from "../auth";
import { useAppSelector } from "../store";

export const SiteAndCompanyOutlet: FC = () => {
  const { companyId } = useParams();
  const { pathname } = useLocation();
  const isUserAuthed = useAppSelector((state) => state.user.isAuth);

  const { user, linkBeforeAuth } = useAuth();
  const navigate = useNavigate();
  const siteId = useAppSelector((state) => state.site?.id);

  const { sites, status: sitesStatus } = useAppSelector((state) => state.sites);

  useEffect(() => {
    if (!isUserAuthed || linkBeforeAuth || !companyId) return;
    const isNoSites = sitesStatus === "fulfilled" && sites.length === 0;
    if (isNoSites)
      pathname.endsWith("dashboard")
        ? navigate(`/company/${companyId}/site/no-id/dashboard`)
        : pathname.endsWith("products")
          ? navigate("/products/no-sites")
          : pathname.includes("campaigns")
            ? navigate("/campaigns/no-sites")
            : navigate(`/company/${companyId}/sites`);
  }, [
    sites.length,
    user,
    linkBeforeAuth,
    navigate,
    sitesStatus,
    companyId,
    isUserAuthed,
    pathname,
  ]);

  return !!siteId && companyId && user && sitesStatus ? (
    <Outlet context={{ siteId, companyId }} />
  ) : null;
};
